"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
function Button(_a) {
    var children = _a.children, _b = _a.disabled, disabled = _b === void 0 ? false : _b, onClick = _a.onClick, _c = _a.loading, loading = _c === void 0 ? false : _c, _d = _a.className, className = _d === void 0 ? "" : _d;
    return ((0, jsx_runtime_1.jsxs)(StyledContainer, __assign({ onClick: onClick, className: "twap-button ".concat(loading ? "twap-button-loading" : "", " ").concat(disabled ? "twap-button-disabled" : "", " ").concat(className), disabled: disabled }, { children: [loading && ((0, jsx_runtime_1.jsx)(StyledLoader, __assign({ className: "twap-button-loader" }, { children: (0, jsx_runtime_1.jsx)(material_1.CircularProgress, { className: "twap-button-loader" }) }))), (0, jsx_runtime_1.jsx)(material_1.Fade, __assign({ in: !loading }, { children: (0, jsx_runtime_1.jsx)(StyledChildren, __assign({ className: "twap-button-children" }, { children: children })) }))] })));
}
var StyledLoader = (0, material_1.styled)(material_1.Box)({
    left: "50%",
    top: "55%",
    transform: "translate(-50%, -50%) scale(0.8)",
    position: "absolute",
});
var StyledContainer = (0, material_1.styled)("button")(function (_a) {
    var disabled = _a.disabled;
    return ({
        position: "relative",
        width: "100%",
        border: "unset",
        fontWeight: 600,
        cursor: disabled ? "unset" : "pointer",
        fontSize: 16,
        opacity: disabled ? 0.6 : 1,
        transition: "0.2s all",
    });
});
var StyledChildren = (0, material_1.styled)(material_1.Box)({});
exports.default = Button;
